<template>
  <div>
    <div
      class="h-100 position-absolute"
      :class="setSemitransparent ? 'semitransparent' : ''"
      v-drag
      id="fence-list"
    >
      <el-row class="table-header m-10">
        <el-col :span="12">
          <span>电子围栏列表</span>
        </el-col>
        <el-col :span="12" class="tr"></el-col>
      </el-row>
      <!-- 路径列表 -->
      <div class="m-t-10 fence-table">
        <el-table
          :data="dataList"
          v-loading="tableLoading"
          class="w-100"
          height="100%"
          @cell-click="moveToFence"
        >
          <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
          <el-table-column prop="name" label="围栏名称" align="center"></el-table-column>
          <el-table-column prop="distance" label="围栏开关" align="center">
            <template #default="{row}">
              <el-switch
                :value="row.isOpen"
                :disabled="switchLoading"
                active-color="#13ce66"
                ref="fenceSwitch"
                inactive-color="#dcdfe6"
                @input="editFenceStatus(row)"
              ></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="m-t-10 r">
        <el-pagination
          background
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes,prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import LocalSense from '@/services/baoChang/localSense'

export default {
  components: {},
  props: ['setSemitransparent', 'currentPlayerId'],
  data() {
    return {
      tableLoading: false,
      pageSize: 15,
      pageNo: 1,
      pageTotal: 0,
      fenceList: [], // 围栏列表
      fenceAreaList: [], // 围栏图层信息
      relationTagIdList: [], // 目标集合
      fenceVertexs: [],
      fenceModelObjects: [], // 围栏对象集合
      switchLoading: false,
      clickTableTimerOut: null,
    }
  },
  created() {
    this.getFenceList()
    this.getRelationTags()
    this.getFenceAreaList()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 前端分页处理
    dataList() {
      return this.fenceList.slice((this.pageNo - 1) * this.pageSize, this.pageNo * this.pageSize)
    },
  },
  watch: {},
  beforeDestroy() {
    if (!_.isEmpty(this.fenceModelObjects)) {
      _.forEach(this.fenceModelObjects, (item) => {
        window.player.Native.ElectoronicRail.destroy(item.objectId)
      })
    }
  },
  methods: {
    // 改变围栏开关状态
    async editFenceStatus(row) {
      this.switchLoading = true
      const detailInfo = await this.getFenceDetail(row.id)
      const fenceVertex = _.map(detailInfo.vertex, (item, index) => {
        return { VERTEX_ID: index, ...item }
      })
      const params = {
        Id: row.id,
        Name: row.name,
        BeginTime: row.begin_TIME,
        EndTime: row.end_TIME,
        DelayTime: row.delaytime,
        RegId: row.regid,
        RegName: row.regName,
        ByPass: row.isOpen ? 1 : 0,
        Vertex: JSON.stringify(fenceVertex),
        FenceType: 0,
        EditedMan: detailInfo.related_TAGID.join(';'),
      }
      const res = await LocalSense.editFence(params)
      this.switchLoading = false
      if (res && res.code === 0) {
        row.isOpen = !row.isOpen
        this.$message.success('操作成功！')
        if (row.isOpen) {
          const fenceObject = await window.player.Native.ElectoronicRail.create(row.id, 2.0)
          _.forEach(detailInfo.vertex, (el) => {
            window.player.Native.ElectoronicRail.addFencePillar(fenceObject, [el.X, el.Y, el.Z])
          })
          this.fenceModelObjects.push({ fenceId: row.id, objectId: fenceObject })
        } else {
          const rowFence = _.find(this.fenceModelObjects, ['fenceId', row.id])
          if (rowFence) {
            _.remove(this.fenceModelObjects, (item) => {
              return item.fenceId === rowFence.fenceId
            })
            console.log(this.fenceModelObjects)
            window.player.Native.ElectoronicRail.destroy(rowFence.objectId)
          }
        }
      } else {
        this.$message.warning(`操作失败，${res.message}`)
      }
    },
    // 点击定位到围栏位置
    moveToFence(row) {
      if (this.clickTableTimerOut) clearTimeout(this.clickTableTimerOut)
      this.clickTableTimerOut = setTimeout(async () => {
        if (window.player && window.player.Native) {
          // 获取模型所在的坐标系
          const mat = await PlayerUtils.call(
            window.player.Native.Model.getModelGlobalMatrix,
            this.currentPlayerId
          )
          const rowFence = _.find(this.fenceModelObjects, ['fenceId', row.id])
          if (rowFence) {
            const aabbRes = await window.player.Native.ElectoronicRail.getAabb(rowFence.objectId)
            const aabb = {
              min: aabbRes[0],
              max: aabbRes[1],
            }
            window.player.Native.Camera.moveToAabb(aabb, mat, 1, 0.5, 2)
          }
        }
      }, 500)
    },
    // 获取围栏详情
    async getFenceDetail(id) {
      const res = await LocalSense.getFenceDetail({
        ID: id,
      })
      if (res && res.code === 0 && res.data && res.data.rows && res.data.vertex) {
        const fenceDetail = res.data.rows
        fenceDetail.related_TAGID = res.data.rows.related_TAGID
          ? res.data.rows.related_TAGID.split(':')
          : ''
        fenceDetail.vertex = _.map(_.sortBy(res.data.vertex, 'VERTEX_ID'), (item) => {
          return _.pick(item, ['X', 'Y', 'Z'])
        })
        return fenceDetail
      }
      return {}
    },
    // 获取电子围栏列表
    async getFenceList() {
      this.tableLoading = true
      const res = await LocalSense.getAllList(0)
      this.tableLoading = false
      if (res && res.code === 0 && res.data && res.data.rows && res.data.vertex) {
        this.fenceList = _.map(res.data.rows, (item) => {
          return { ...item, isOpen: item.bypass === 0 }
        })
        this.pageTotal = this.fenceList.length
        this.fenceVertexs = res.data.vertex
        // 允许编辑
        window.player.Native.ElectoronicRail.setEditMode(true)
        _.forEach(this.fenceVertexs, async (item) => {
          const currentFence = _.find(this.fenceList, ['id', item[0].EEFENCE_ID])
          if (currentFence && currentFence.bypass === 0) {
            // 初始化
            const fenceObject = await window.player.Native.ElectoronicRail.create(
              item[0].EEFENCE_ID,
              2.0
            )
            _.forEach(item, (el) => {
              window.player.Native.ElectoronicRail.addFencePillar(fenceObject, [el.X, el.Y, el.Z])
            })
            this.fenceModelObjects.push({ objectId: fenceObject, fenceId: currentFence.id })
          }
        })
      }
    },
    // 获取电子围栏图层信息
    async getFenceAreaList() {
      const res = await LocalSense.getFenceAreaInfo({
        type: 9,
        /** 0：查询全部 1：基站编组
            2：电子围栏 3：考勤区域
            4：巡检区域 5：电子点名
            6：基站信息 7：视频联动
            8：场景信息 9：地图信息 */
      })
      if (res && res.code === 0 && res.data && res.data.rows) {
        this.fenceAreaList = res.data.rows['地图信息']
      }
    },
    // 查询权限内目标集合
    async getRelationTags() {
      const res = await LocalSense.getRelationTags()
      console.log(res)
      if (res && res.code === 0 && res.data && res.data.rows) {
        this.relationTagIdList = res.data.rows
      }
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../css/semitransparent.scss';
#fence-list {
  height: 500px;
  width: 400px;
  left: 8px;
  top: 46px;
  background-color: rgba(255, 255, 255, 0.76);
  border-radius: 4px;
  z-index: 99;
  .fence-table {
    height: calc(100% - 100px);
  }
}

</style>
